import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * This component acts as a central handler for Firebase Auth Actions
 * (like Reset Password, Verify Email) if configured in the Firebase Console.
 *
 * If the user clicked a link generated by the Trainer app (identified by continueUrl),
 * we navigate them to our custom frontend. Otherwise, we redirect them to the
 * default Firebase auth action handler for the client app to handle natively.
 */
export const AuthAction = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');
    const continueUrl = searchParams.get('continueUrl');

    // Check if this action originated from the Trainer App
    const isTrainerContext = continueUrl && continueUrl.includes('onboarding-trainer');

    if (isTrainerContext && mode === 'resetPassword' && oobCode) {
      // Redirect to the custom Trainer Reset Password screen
      navigate(`/onboarding-trainer/reset-password?oobCode=${oobCode}`, { replace: true });
      return;
    }

    // Fallback: Redirect all other actions (or non-trainer actions)
    // to the default Firebase Auth Action handler
    const firebaseDefaultUrl = `https://minipt-1.firebaseapp.com/__/auth/action${window.location.search}`;
    window.location.replace(firebaseDefaultUrl);
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#060723',
        color: 'white',
      }}
    >
      Loading...
    </div>
  );
};
